export const RATED_CANDIDATES_DIALOG_KEY = 'rated-candidates-dialog-key';
export const SHARED_CANDIDATE_DIALOG_KEY = 'shared-candidate-dialog-key';
export const CENTRAL_INBOX_DIALOG_KEY = 'central-inbox-dialog-key';
